import { render, staticRenderFns } from "./delete-document-modal.vue?vue&type=template&id=6e078f38&"
import script from "./delete-document-modal.vue?vue&type=script&lang=js&"
export * from "./delete-document-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports